<template>
    <b-modal v-if="!loading" id="client_form" ref="client_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Client' : 'Edit Client' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="6">
                    <b-form-group label="First Name" class="has-float-label">
                        <template v-slot:label>
                            <span>First Name <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.f_name" :class="{'border-danger': 'f_name' in errors}"
                                      @input="'f_name' in errors ? (delete errors.f_name) : ''"
                                      autocomplete="off" placeholder="First Name"/>

                        <b-form-invalid-feedback :state="!('f_name' in errors)"
                                                 v-text="'f_name' in errors ? errors.f_name[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Last Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Last Name <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.l_name" :class="{'border-danger': 'l_name' in errors}"
                                      @input="'l_name' in errors ? (delete errors.l_name) : ''"
                                      autocomplete="off" placeholder="Last Name"/>
                        <b-form-invalid-feedback :state="!('l_name' in errors)"
                                                 v-text="'l_name' in errors ? errors.l_name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Gender" class="has-float-label">
                        <template v-slot:label>
                            <span>Gender <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateGender" v-model="selected.gender" :options="genders"
                                  :border-danger="'gender' in errors"/>

                        <b-form-invalid-feedback :state="!'gender' in errors"
                                                 v-text="'gender' in errors ? errors.gender[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Date of Birth" class="has-float-label">
                        <template v-slot:label>
                            <span>Date of Birth <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single" popover-align="right"
                            v-model="datepicker.dob"
                            @input="'dob' in errors ? delete errors.dob : ''"
                            :input-props="{ class:'form-control' + ('dob' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'dob' in errors"
                                                 v-text="'dob' in errors ? errors.dob[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group class="mb-4">
                        <b-form-file v-model="image" placeholder="Choose a picture..."/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="SSN" class="has-float-label">
                        <template v-slot:label>
                            <span>SSN <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.ssn" v-mask="'###-##-####'"
                                      :class="{'border-danger': 'ssn' in errors}"
                                      @input="'ssn' in errors ? (delete errors.ssn) : ''"
                                      autocomplete="off" placeholder="XXX-XX-XXX"/>

                        <b-form-invalid-feedback :state="!('ssn' in errors)"
                                                 v-text="'ssn' in errors ? errors.ssn[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Medicaid" class="has-float-label">
                        <b-form-input type="text" v-model="form.medicaid" autocomplete="off" placeholder="Medicaid"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Email" class="has-float-label">
                        <b-form-input type="text" v-model="form.email" autocomplete="off" placeholder="your@email.com"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Phone" class="has-float-label">
                        <b-form-input type="text" v-mask="'(###) ###-####'" v-model="form.phone"
                                      autocomplete="off" placeholder="(XXX) XXX-XXXX"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Referral Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Referral Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-align="right" popover-visibility="focus" mode="single"
                            v-model="datepicker.ref_date"
                            @input="'ref_date' in errors ? delete errors.ref_date : ''"
                            :input-props="{ class:'form-control' + ('ref_date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'ref_date' in errors"
                                                 v-text="'ref_date' in errors ? errors.ref_date[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Facility" class="has-float-label">
                        <template v-slot:label>
                            <span>Facility <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                  :border-danger="'facility_id' in errors"/>

                        <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                 v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row class="mb-4">
                <b-colxx md="12">
                    <vue-dropzone ref="fileDropZone" id="dropzone"
                                  @vdropzone-error="attachmentError"
                                  :destroy-dropzone="false" :options="dropzoneOptions"/>
                </b-colxx>
            </b-row>

            <b-row v-if="edit">
                <b-colxx md="12">
                    <FilesList v-if="form.attachments" :edit="true" :files="form.attachments.data"
                               @delete="deleteFile"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('client_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitClient">Submit</state-button>

            <state-button v-else variant="primary" :click="updateClient">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from 'vuex';
import moment from "moment";
import VueDropzone from 'vue2-dropzone';
import StateButton from "../../../../../components/Common/StateButton";
import FilesList from "../../../../../components/Listing/FilesList";

export default {
    name: "ClientFormModal",

    components: {
        FilesList,
        VueDropzone,
        StateButton,
    },

    props: [
        'edit',
    ],

    data() {
        return {
            loading: true,
            image: null,
            genders: [
                {label: 'Male', value: 'Male'},
                {label: 'Female', value: 'Female'},
                {label: 'Other', value: 'Other'},
            ],
            datepicker: {
                dob: null,
                ref_date: null,
            },
            selected: {
                facility: [],
                gender: [],
            },
            deleted_attachments: [],
            dropzoneOptions: {
                url: 'url',
                thumbnailHeight: 160,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                maxFilesize: 10,
                previewTemplate: this.dropzoneTemplate(),
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.accessToken
                },
                dictDefaultMessage: 'Drop or Click here to upload REFERRAL LETTER.<br>Max file size 10MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                autoProcessQueue: false
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getClientForm',
            facilities: 'getSelectFacilities',
            errors: 'getClientErrors',
        }),
    },

    watch: {
        form() {
            if (this.edit) {
                this.selected.gender = this.form.select_gender;
                this.selected.facility = this.form.select_facility;

                this.datepicker.dob = moment(this.form.dob).toDate();
                this.datepicker.ref_date = moment(this.form.ref_date).toDate();
            }
        },

        'datepicker.ref_date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.ref_date = null;
            this.form.ref_date = moment(date).format('YYYY-MM-DD');
        },

        'datepicker.dob'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.dob = null;
            this.form.dob = moment(date).format('YYYY-MM-DD');
        },
    },

    mounted() {
        this.getForm();
    },

    methods: {
        deleteFile(file) {
            this.deleted_attachments.unshift(file);
            this.form.attachments.data.splice(file.index, 1);
        },

        async getForm() {
            await this.$store.dispatch('fetchSelectFacilities');

            return this.loading = false;
        },

        updateGender(field) {
            if (field) {
                this.form.gender = field.value;
            } else {
                this.form.gender = '';
            }
            'gender' in this.errors ? delete this.errors.gender : '';
        },

        updateFacility(field) {
            if (field) {
                this.form.facility_id = field.facility_id;
            } else {
                this.form.facility_id = '';
            }
            'facility_id' in this.errors ? delete this.errors.facility_id : '';
        },

        submitClient() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitClient', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new client!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('client_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateClient() {
            let payload = {
                ...this.form,
                deleted_attachments: this.deleted_attachments,
            };

            return new Promise((success, fail) => {
                this.$store.dispatch('updateClient', payload)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the client!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('client_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        uploadFiles(client) {
            if (this.image) {
                let image = new FormData();
                image.append('image', this.image);

                axios.post('/api/hms/clients/' + client.client_id + '/image', image)
                    .catch(error => {
                        console.log(error);
                    });
            }

            let url = '/api/hms/clients/' + client.client_id + '/attachments';

            this.$refs.fileDropZone.setOption('url', url);

            this.$refs.fileDropZone.processQueue(client);
        },

        attachmentError(file, message, xhr) {
            this.$refs.fileDropZone.removeFile(file);
            this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                duration: 6000,
                permanent: false
            });
        },

        dropzoneTemplate() {
            return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        resetForm() {
            this.$store.commit('setClientForm');

            this.selected = {
                gender: [],
            };

            this.deleted_attachments = [];

            this.datepicker = {
                dob: null,
                ref_date: null,
            };
        },
    },
}
</script>

<style scoped>

</style>
